export default __webpack_public_path__ + "media/images/datatables/resources/details_close-a357f7deec7d483d369a04af76d4ccb2.png";